const AppConfig = {
  PathApi: "https://api.ohbo1.com/api/server/connect",
};
export default AppConfig;
